import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../../modules/toast/Toast";
import { deleteUser } from "../../core/_request";
import { useQueryResponse } from "../../core/QueryResponseProvider";

const Action = (props: any) => {
  const navigate = useNavigate();
  const dataUsers = useQueryResponse();
  const [showModal, setShowModal] = useState(false);
  const { notify } = useToast();

  const handleDelete = async () => {
    try {
      const response = await deleteUser({ id: props.row._id });
      if (response.responseCode === "200") {
        notify("success", "Submit Success");
        dataUsers.refetch();
      } else {
        notify("error", response.responseMessage);
      }
    } catch (err: any) {
      notify("error", err?.response.data.responseMessage);
    }
    setShowModal(false);
  };

  return (
    <>
      <div className="d-flex justify-content-end flex-shrink-0">
        {/* Dropdown for All Actions */}
        <div className="dropdown">
          <button
            className="btn btn-sm btn-light btn-active-light-primary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fas fa-ellipsis-v"></i>
          </button>

          <ul className="dropdown-menu dropdown-menu-end shadow-sm">
            <li>
              <h6 className="dropdown-header text-gray-600 fw-bold fs-7">
                <i className="fas fa-user me-2"></i>
                {props.row.userName || "User Actions"}
              </h6>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <button
                className="dropdown-item d-flex align-items-center py-2"
                onClick={() => navigate(`detail/${props.row._id}`)}
              >
                <div className="symbol symbol-20px me-3">
                  <div className="symbol-label bg-light-primary">
                    <i className="fas fa-eye text-primary fs-8"></i>
                  </div>
                </div>
                <div>
                  <div className="fw-bold">View Details</div>
                  <div className="text-muted fs-8">See user information</div>
                </div>
              </button>
            </li>
            <li>
              <button
                className="dropdown-item d-flex align-items-center py-2"
                onClick={() => navigate(`edit/${props.row._id}`)}
              >
                <div className="symbol symbol-20px me-3">
                  <div className="symbol-label bg-light-warning">
                    <i className="fas fa-edit text-warning fs-8"></i>
                  </div>
                </div>
                <div>
                  <div className="fw-bold">Edit User</div>
                  <div className="text-muted fs-8">Modify user settings</div>
                </div>
              </button>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <button
                className="dropdown-item d-flex align-items-center py-2 text-danger"
                onClick={() => setShowModal(true)}
              >
                <div className="symbol symbol-20px me-3">
                  <div className="symbol-label bg-light-danger">
                    <i className="fas fa-trash text-danger fs-8"></i>
                  </div>
                </div>
                <div>
                  <div className="fw-bold">Delete User</div>
                  <div className="text-muted fs-8">Set User Inactive</div>
                </div>
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Enhanced Modal */}
      {showModal && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content shadow-lg border-0">
              <div className="modal-header bg-primary">
                <h5 className="modal-title text-white d-flex align-items-center">
                  <div className="symbol symbol-30px me-3">
                    <div className="symbol-label bg-warning">
                      <i className="fas fa-exclamation-triangle text-white"></i>
                    </div>
                  </div>
                  Confirm Deletion
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body p-8">
                <div className="text-center mb-6">
                  <div className="symbol symbol-90px symbol-circle mx-auto mb-4">
                    <div className="symbol-label bg-light-warning">
                      <i className="fas fa-user-times text-warning fs-2x"></i>
                    </div>
                  </div>
                  <h4 className="fw-bold text-gray-800 mb-3">
                    Delete User Account
                  </h4>
                  <p className="text-gray-600 fs-6 mb-4">
                    Are you sure you want to permanently delete this user
                    account? This action cannot be undone.
                  </p>
                  <div className="bg-light-warning rounded p-4">
                    <div className="d-flex align-items-center">
                      <i className="fas fa-user text-warning me-3 fs-4"></i>
                      <div className="text-start">
                        <div className="fw-bold text-gray-800">
                          {props.row.fullName || "Unknown User"}
                        </div>
                        <div className="text-muted fs-7">
                          @{props.row.userName || "unknown"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer border-0 pt-0">
                <button
                  type="button"
                  className="btn btn-light btn-lg"
                  onClick={() => setShowModal(false)}
                  style={{
                    color: "#6c757d !important",
                    transition: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#6c757d";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#6c757d";
                  }}
                >
                  <i
                    className="fas fa-times me-2"
                    style={{ color: "#6c757d" }}
                  ></i>
                  <span style={{ color: "#6c757d" }}>Cancel</span>
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-lg"
                  onClick={handleDelete}
                  style={{
                    color: "white !important",
                    transition: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "white";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "white";
                  }}
                >
                  <i
                    className="fas fa-trash me-2"
                    style={{ color: "white" }}
                  ></i>
                  <span style={{ color: "white" }}>Delete User</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Action;
